import truncate from "lodash/truncate";

export const format = (str) => {
  return truncate(str.replace(/[^A-Za-z ]/g, "").replace(/ {2,}/g, " "), {
    length: 18,
    omission: "",
  });
};
